<script>
import API from '../src/JSON/APIJson.json'
import axios from 'axios'
var menustatus = true;
var FieldType = "";
var FieldName = "";
var fieldID = 0;
var FieldPageName = "";
var Breadcrumbs = [];
var BreadcrumbsUrl = [];
var Page_ID = "";
//var CGIUID = "";
//var CGIAccount = "";
var person_img_n = "";
var Base64 = {

    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

    // public method for encoding
    encode: function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

        }

        return output;
    },

    // public method for decoding
    decode: function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = Base64._utf8_decode(output);

        return output;

    },

    // private method for UTF-8 encoding
    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    },

    // private method for UTF-8 decoding
    _utf8_decode: function (utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;

        while (i < utftext.length) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }

        return string;
    }

}
var Base64Utils = {

    replaceAll: function (str, old_value, new_value) {
        return str.toString().split(old_value).join(new_value)
    },
    replace: function (str) {
        var newStr = str
        newStr = this.replaceAll(str, "i", "!");
        newStr = this.replaceAll(newStr, "a", "-");
        newStr = this.replaceAll(newStr, "B", "(");
        newStr = this.replaceAll(newStr, "j", ")");
        newStr = this.replaceAll(newStr, "K", "$");
        newStr = this.replaceAll(newStr, "M", "@");
        //newStr = this.replaceAll(newStr, "g", "*");
        newStr = this.replaceAll(newStr, "n", "~");
        return newStr;
    },
    recover: function (str) {
        var newStr = str
        newStr = this.replaceAll(str, "!", "i");
        newStr = this.replaceAll(newStr, "-", "a");
        newStr = this.replaceAll(newStr, "(", "B");
        newStr = this.replaceAll(newStr, ")", "j");
        newStr = this.replaceAll(newStr, "$", "K");
        newStr = this.replaceAll(newStr, "@", "M");
        //newStr = this.replaceAll(newStr, "*", "g");
        newStr = this.replaceAll(newStr, "~", "n");
        newStr = this.replaceAll(newStr, " ", "+");
        return newStr;
    },
    // decode
    atou: function (str) {
        str = this.recover(str);
        //console.log(str)
        return decodeURIComponent(escape(window.atob(str)));
    },
    //Encrtpy
    utoa: function (str) {
        var encode_str = window.btoa(unescape(encodeURIComponent(str)));
        return this.replace(encode_str);
    }

}
function DBDataToArray(JsonData, FieldArray) {
    if (JsonData.length > 0) {
        for (var item in JsonData) {
            var s_total = ''; for (var item2 in FieldArray) {
                s_total = s_total + JsonData[item][FieldArray[item2]].toUpperCase();
            }
            JsonData[item].Total = s_total;
        }
    }
    return JsonData
};
function GetPermission(Page, UserId, callback) {
    let url = API[0].GetPagePermssion + Page + "/" + UserId;
    axios
        .get(url)
        .then(res => {
            callback(res.data)
            //return res.data
        })
        .catch(err => {
            return null
        });
};
function roundDecimal(val, precision) {
    return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
}
async function GetComboItemsBySqlID(sql, cpno) {
    var data = '';
    var post_data = {
        searchData: sql,
        CPNO: cpno
    };
    await axios({
        method: 'post',
        url: API.GetComboItemsBySqlID,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(fun)
        console.log(error);
    });
    return data;
};
async function GetComboItemsByID(sql) {
    var data = '';
    var post_data = {
        searchData: sql,
    };
    await axios({
        method: 'post',
        url: API.GetComboItemsByID,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data
};
async function GetComboItemsBySqlIDnInput(sql) {
    var data = '';
    var post_data = {
        CPNO: sql.CPNO,
        sCDTYPE: sql.sCDTYPE,
        sInput: sql.sInput,
    };
    await axios({
        method: 'post',
        url: API.GetComboItemsBySqlIDnInput,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data;
};
async function GetDate(Format = '', addD = "0", addM = "0", addY = "0") {
    var data = '';
    var post_data = {
        Format: Format,
        addD: addD,
        addM: addM,
        addY: addY
    };
    await axios({
        method: 'post',
        url: API.GetDate,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data;
};
async function GetUserGroup(pnm, phone, from, to) {
    var data = [];
    var post_data = {
        PNM: pnm,
        PHONE: phone,
        itemF: from,
        itemT: to
    };
    await axios({
        method: 'post',
        url: API.GetUser,
        data: post_data,
    }).then(res => {
        var temp = res.data;
        if (temp.length > 0) {
            data = temp[0].group;
        }
        else {
            data = '';
        }
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data;
};
function DateFormat(date, str) {
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    return [date.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
    ].join(str);
};
async function GetIVNOW(data1, data2) {
    var data = '';
    var post_data = {
        searchData: data1,
        data2: data2
    };
    await axios({
        method: 'post',
        url: API.GetIVNOW,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data
};
async function GetCURRATE(sql) {
    var data = '';
    var post_data = sql;
    await axios({
        method: 'post',
        url: API.GetCURRATE,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data
};
async function GetSuplList(Type, Userid, ShopNO) {
    var data
    var post_data = {
        searchData: Base64Utils.utoa(JSON.stringify({
            Type: Type,
            ShopNO: Base64Utils.atou(ShopNO),
            Userid: Base64Utils.atou(Userid)
        })),
    };
    await axios({
        method: 'post',
        url: API.GetSuplList,
        data: post_data,
    }).then(res => {
        data = JSON.parse(Base64Utils.atou(res.data));
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data;
};
async function GetTime() {
    var data = '';
    var post_data = {
    };
    await axios({
        method: 'post',
        url: API.GetTime,
        data: post_data,
    }).then(res => {
        data = res.data;
    }
    ).catch(function (error) { // 請求失敗處理
        console.log(error);
    });
    return data;
};
export default
    {
        menustatus,
        Base64,
        Base64Utils,
        DBDataToArray,
        FieldType,
        FieldName,
        FieldPageName,
        fieldID,
        Breadcrumbs,
        BreadcrumbsUrl,
        //CGIUID,
        //CGIAccount,
        Page_ID,
        person_img_n,
        GetPermission,
        roundDecimal,
        GetComboItemsBySqlID,
        GetComboItemsByID,
        GetComboItemsBySqlIDnInput,
        GetDate,
        DateFormat,
        GetIVNOW,
        GetCURRATE,
        GetUserGroup,
        GetSuplList,
        GetTime
    }
</script>



// WEBPACK FOOTER //
// src/Global.vue